module.exports = "../study/imgs/maps/Kanagawa/S8/WaterEnvironment/Chlmax/Kanagawa_Chlmax_MRI_RCP45_Now.png";